<template>
  <Wrapper>
    <Loading v-if="isLoading"></Loading>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <main
      class="main"
      v-if="!isLoading && !isBadRequest && !isCreateServerError"
    >
      <!--表示用-->
      <CertificateWidth1000 :dataRunner="dataRunner"></CertificateWidth1000>
      <div class="download-button">
        <PrimaryButton type="button" @click.native="imageDownload">
          {{ getSentenceCertificate.download[lang] }}
        </PrimaryButton>
      </div>
    </main>
    <!-- 保存用（画面には表示しない(位置 : -9999px)）width: 4093px; height: 2894px; -->
    <!-- IE用 -->
    <CertificateInternetExplorer
      :dataRunner="dataRunner"
      id="js-download"
      v-if="
        !isLoading &&
        !isBadRequest &&
        !isCreateServerError &&
        isInternetExplorer
      "
    >
    </CertificateInternetExplorer>
    <CertificateWidth4000
      :dataRunner="dataRunner"
      id="js-download"
      v-if="
        !isLoading &&
        !isBadRequest &&
        !isCreateServerError &&
        !isInternetExplorer
      "
    >
    </CertificateWidth4000>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../../components/pc/Wrapper";
import Loading from "../../../../components/pc/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import InternalServerError from "../../../../components/common/status/InternalServerError";
import PrimaryButton from "../../../../components/pc/oauth/PrimaryButton";
import CertificateWidth1000 from "../../../../components/common/CertificateWidth1000";
import CertificateWidth4000 from "../../../../components/common/CertificateWidth4000";
import CertificateInternetExplorer from "../../../../components/common/CertificateInternetExplorer";
import certificate from "../../../../assets/constants/ranking/certificate/certificate";
import html2canvas from "html2canvas";
import Download from "downloadjs";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";

export default {
  data() {
    return {
      isLoading: true,
      isBadRequest: false,
      isCreateServerError: false,
      isInternetExplorer: false,
      dataRunner: null,
    };
  },
  created() {
    // IEの時はIE専用のコンポーネントを呼ぶ
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes("msie") || userAgent.includes("trident")) {
      this.isInternetExplorer = true;
    }
  },
  async mounted() {
    // ランナー情報取得
    const RankingRepository = RepositoryFactory.get("ranking");
    try {
      const response = await RankingRepository.getRunner({
        event: this.$route.query.event,
        runner: this.$route.query.runner,
        lang: this.lang,
      });
      this.dataRunner = response.data;
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    imageDownload: function () {
      // 非表示の場合変換できないので一瞬表示する
      document.getElementById("js-download").classList.remove("none");
      // 既存のcanvasタグがある場合は削除
      if (document.querySelector("#canvas-tag")) {
        // IEでremoveが効かない
        // document.querySelector("#canvas-tag").remove();
        const elm = document.querySelector("#canvas-tag");
        elm.parentNode.removeChild(elm);
      }
      // 変換処理
      // PCだと画像が欠けることがあるので scrollX,scrollYを指定する
      html2canvas(document.getElementById("js-download"), {
        scrollX: 0,
        scrollY: -window.scrollY,
      })
        .then(function (canvas) {
          document.getElementById("js-download").classList.add("none");
          const element = document.getElementById("app");
          const tag = element.appendChild(canvas);
          tag.id = "canvas-tag";
          tag.classList.add("none");
          const dataUrl = tag.toDataURL();

          // IEはダウンロード機能が使用できないため別対応
          if (window.navigator.msSaveBlob) {
            const encodeData = atob(dataUrl.replace(/^.*,/, ""));
            const outData = new Uint8Array(encodeData.length);
            for (let i = 0; i < encodeData.length; i++) {
              outData[i] = encodeData.charCodeAt(i);
            }
            const blob = new Blob([outData], ["image/png"]);
            window.navigator.msSaveOrOpenBlob(blob, "certificate_ms.png");
            return;
          }
          Download(dataUrl, "certificate.png");
        })
        .catch(function (e) {
          console.error(e);
        });
    },
  },
  computed: {
    getSentenceCertificate: function () {
      return certificate;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  components: {
    Wrapper,
    Loading,
    BadRequest,
    InternalServerError,
    PrimaryButton,
    CertificateWidth1000,
    CertificateWidth4000,
    CertificateInternetExplorer,
  },
  name: "Certificate",
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=EB+Garamond");
.main {
  .download-button {
    margin: 40px 0 0 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/ranking/certificate/Certificate.vue